(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3931],{

/***/ 3558:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guru-ai-bot",
      function () {
        return __webpack_require__(389);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ guru_ai_bot; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 31 modules
var TextField = __webpack_require__(9033);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(431);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(8456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
;// CONCATENATED MODULE: ./components/DatePicker.tsx



const DatePicker = (param)=>{
    let { placeholder , style , value , setDate , error  } = param;
    const fromDateInput = (0,react.useRef)(null);
    const [hideCustomCalendar, setHideCustomCalendar] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            position: "relative",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
            inputRef: fromDateInput,
            placeholder: placeholder,
            label: placeholder,
            fullWidth: true,
            margin: "normal",
            value: value,
            onFocus: (e)=>{
                e.target.type = "date";
                setHideCustomCalendar(false);
            },
            onBlur: (e)=>{
                if (!e.target.value) e.target.type = "text";
                setHideCustomCalendar(true);
            },
            onChange: (e)=>setDate(e.target.value),
            sx: {
                ...style
            },
            error: !!error,
            helperText: error
        })
    });
};
/* harmony default export */ var components_DatePicker = (DatePicker);

;// CONCATENATED MODULE: ./pages/guru-ai-bot/index.tsx




 // Ensure the path is correct
const formFields = [
    {
        name: "name",
        label: "Name",
        type: "text",
        validation: {
            required: "Name is required"
        }
    },
    {
        name: "gpId",
        label: "GP ID",
        type: "text",
        validation: {
            required: "GP ID is required"
        }
    },
    {
        name: "gender",
        label: "Gender",
        type: "select",
        options: [
            "Male",
            "Female"
        ],
        validation: {
            required: "Gender is required"
        }
    },
    {
        name: "age",
        label: "Age",
        type: "text",
        validation: {
            required: "Age is required",
            pattern: {
                value: /^[0-9]+$/,
                message: "Age must be a valid number"
            }
        }
    },
    {
        name: "tier",
        label: "Tier",
        type: "select",
        options: [
            "Gold",
            "Silver",
            "Platinum"
        ],
        validation: {
            required: "Tier is required"
        }
    },
    {
        name: "primaryProduct",
        label: "Primary Product",
        type: "select",
        options: [
            "Products",
            "Brands",
            "Both"
        ],
        validation: {
            required: "Primary Product is required"
        }
    },
    {
        name: "lastLeadCreation",
        label: "Last Lead Creation",
        type: "date",
        validation: {
            required: "Last Lead Creation date is required"
        }
    },
    {
        name: "lastLeadSale",
        label: "Last Lead Sale",
        type: "date",
        validation: {
            required: "Last Lead Sale date is required"
        }
    },
    {
        name: "lastActiveDate",
        label: "Last Active Date",
        type: "date",
        validation: {
            required: "Last Active Date is required"
        }
    },
    {
        name: "sessionId",
        label: "Session ID",
        type: "text",
        validation: {}
    }
];
const GromoGuruForm = ()=>{
    const { handleSubmit , control , formState: { errors  } , setValue  } = (0,index_esm/* useForm */.cI)();
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const initiateChat = async (payload)=>{
        try {
            const response = await fetch("https://guru-stg.gromo.in/api/v1/guru/initiate/chat", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
            const responseData = await response.json();
            sessionStorage.setItem("sessionId", responseData === null || responseData === void 0 ? void 0 : responseData.sessionId);
            (responseData === null || responseData === void 0 ? void 0 : responseData.previousChats) && sessionStorage.setItem("prevMsg", JSON.stringify(responseData === null || responseData === void 0 ? void 0 : responseData.previousChats));
            window.location.href = "/guru-ai-bot/chat?message=".concat(encodeURIComponent(responseData.message));
        } catch (error) {
            console.error("Error sending API request:", error);
        }
    };
    const onSubmit = async (data)=>{
        setIsLoading(true);
        const payload = {
            entityId: data.gpId,
            entityType: "GP",
            sessionId: data.sessionId,
            entityData: {
                demographicData: {
                    gender: data.gender.toLowerCase(),
                    age: data.age,
                    name: data.name
                },
                performanceData: {
                    tier: data.tier.toLowerCase(),
                    primaryProduct: data.primaryProduct.toLowerCase(),
                    lastLeadCreationDate: new Date(data.lastLeadCreation).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    }),
                    lastSaleDate: new Date(data.lastLeadSale).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    }),
                    lastActiveTime: data.lastActiveDate || ""
                }
            }
        };
        sessionStorage.setItem("entityId", data.gpId);
        sessionStorage.setItem("formData", JSON.stringify(data));
        await initiateChat(payload);
        setIsLoading(false);
    };
    (0,react.useEffect)(()=>{
        const savedData = sessionStorage.getItem("formData");
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            Object.keys(parsedData).forEach((key)=>{
                setValue(key, parsedData[key]);
            });
        }
    }, [
        setValue
    ]);
    const renderField = (field)=>{
        var ref;
        const error = (ref = errors[field.name]) === null || ref === void 0 ? void 0 : ref.message;
        switch(field.type){
            case "text":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: field.name,
                    control: control,
                    defaultValue: "",
                    rules: field.validation,
                    render: (param)=>/*#__PURE__*/ {
                        let { field: controllerField  } = param;
                        return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            ...controllerField,
                            label: field.label,
                            type: field.name === "age" ? "number" : "text",
                            fullWidth: true,
                            margin: "normal",
                            error: !!error,
                            helperText: error
                        });
                    }
                }, field.name);
            case "select":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: field.name,
                    control: control,
                    defaultValue: "",
                    rules: field.validation,
                    render: (param)=>/*#__PURE__*/ {
                        let { field: controllerField  } = param;
                        return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            ...controllerField,
                            label: field.label,
                            select: true,
                            fullWidth: true,
                            margin: "normal",
                            error: !!error,
                            helperText: error,
                            children: field.options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                    value: option,
                                    children: option
                                }, option))
                        });
                    }
                }, field.name);
            case "date":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    name: field.name,
                    control: control,
                    defaultValue: "",
                    rules: field.validation,
                    render: (param)=>/*#__PURE__*/ {
                        let { field: controllerField  } = param;
                        return (0,jsx_runtime.jsx)(components_DatePicker, {
                            placeholder: field.label,
                            style: {
                                marginBottom: "16px"
                            },
                            value: controllerField.value,
                            setDate: (date)=>controllerField.onChange(date),
                            error: error
                        });
                    }
                }, field.name);
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            padding: 3,
            backgroundColor: "#f4f4f4"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                maxWidth: 720,
                width: "100%",
                padding: 4,
                backgroundColor: "#fff",
                borderRadius: 2,
                boxShadow: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h4",
                    component: "h1",
                    gutterBottom: true,
                    textAlign: "center",
                    children: "Gromo Guru"
                }),
                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "300px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 2,
                            children: formFields.map((field)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    children: renderField(field)
                                }, field.name))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "submit",
                            variant: "contained",
                            color: "primary",
                            fullWidth: true,
                            sx: {
                                backgroundColor: "#25d366",
                                "&:hover": {
                                    backgroundColor: "#1db954"
                                },
                                borderRadius: "50px",
                                padding: "10px 20px",
                                fontWeight: 600,
                                mt: 3
                            },
                            children: "Ask Me!!"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var guru_ai_bot = (GromoGuruForm);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3581,6886,6499,7850,5363,440,9774,2888,179], function() { return __webpack_exec__(3558); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);